import React, { useRef } from 'react';
import { useOpenExternalEventPopup } from 'shared/hooks/use-open-external-event-popup';
import { ExternalCalendarEvent } from 'shared/types/external-calendar-event';

import * as Styled from './external-events-list.style';

export type ExternalEventRowProps = {
  event: ExternalCalendarEvent;
  label: string;
  isPast: boolean;
};

export const ExternalEventRow: React.FC<ExternalEventRowProps> = ({
  event,
  label,
  isPast,
}) => {
  const containerRef = useRef<HTMLAnchorElement>(null);
  const allDay = !!event.start.date && !!event.end.date;

  const { eventTarget, onOpen } = useOpenExternalEventPopup(containerRef, {
    externalId: event.id,
    title: event.title,
    allDay,
    start: event.start.dateTime ?? event.start.date ?? undefined,
    end: event.end.dateTime ?? event.end.date ?? undefined,
    connectionId: event.connectionId,
    calendarId: event.calendarId,
    url: event.url,
  });

  return (
    <Styled.ListItem>
      <Styled.EventContainer
        ref={containerRef}
        as={eventTarget ? 'button' : !event.url ? 'span' : undefined}
        type={eventTarget ? 'button' : undefined}
        onClick={eventTarget ? onOpen : undefined}
        href={eventTarget ? undefined : event.url}
        target={eventTarget ? undefined : '_blank'}
        rel={eventTarget ? undefined : 'noreferrer'}
        $isPast={isPast}
      >
        <Styled.Color $color={event.color} />
        <Styled.Time>{label}</Styled.Time>
        <Styled.Title>{event.title}</Styled.Title>
      </Styled.EventContainer>
    </Styled.ListItem>
  );
};
